import { useUpdatePatientReportMutation } from '../api';

export const useUpdateReportUseCase = () => {
  const [updateReport, { isLoading, isSuccess, data, error }] = useUpdatePatientReportMutation();

  return { updateReport, data, isLoading, isSuccess, error };
};
